import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URLS, PLATFORM_TYPE } from "../constants/constants";
import { decryptPayload } from "../app/decryptUtils";
export const captchaServiceApi = createApi({
  reducerPath: "captchaServiceApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URLS.CAPTCHA_BASE_URL }),
  endpoints: (builder) => ({
    getCaptchaService: builder.query({
      // headers: {
      //   // "Content-type": "image/jpeg ",
      //   "Keep-Alive": true,
      // },
      query: () => ({
        headers: {
          appName:"ETPBMS2.0",
          applicationName: "ETPBMS2.0",
          "PLATFORM-TYPE":PLATFORM_TYPE
         },
        url: "/api/v1/captcha-service/getCaptcha/login",
        method: "Get",
      }),
     async transformResponse(response) {
        const decrypted = await decryptPayload(response.data);
        return decrypted;
      },
    }),
    getCaptchaVerify: builder.query({
      query: (data) => ({
        headers: {
          appName:"ETPBMS2.0",
           applicationName: "ETPBMS2.0",
          "PLATFORM-TYPE":PLATFORM_TYPE
         },
        url: `/api/v1/captcha-service/verifyCaptcha/${data.captchaId}?id=${data.id}`,
        method: "Post",
        body: {},
        // responseHandler: (response) => response.text(),
      }),
      // transformResponse: (resp) => {
      //   console.log(resp);
      //   return {
      //     status: resp === "Captcha Valid" ? 200 : 500,
      //     message: "done",
      //   };
      // },
    }),
  }),
});
export const { useGetCaptchaServiceQuery, useGetCaptchaVerifyQuery } =
  captchaServiceApi;
